import React from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "./photo-gallery.scss";

interface PhotoGalleryProps {
	content: string;
}

export default function PhotoGallery({ content }: PhotoGalleryProps) {
	const extractImages = (html: string): string[] => {
		const imgRegex = /<img[^>]+src="([^">]+)"/g;
		const imageUrls: string[] = [];
		let match;

		while ((match = imgRegex.exec(html)) !== null) {
			if (match[1]) {
				imageUrls.push(match[1]);
			}
		}

		return imageUrls;
	};

	const images = extractImages(content);

	if (images.length === 0) {
		return null;
	}

	return (
		<div className="photo-gallery">
			<Swiper
				modules={[Navigation, Pagination, Autoplay]}
				navigation
				pagination={{
					clickable: true,
				}}
				autoplay={{
					delay: 3000,
					disableOnInteraction: false,
					pauseOnMouseEnter: true,
				}}
				loop={true}
				className="swiper-container"
				spaceBetween={20}
				slidesPerView={1}
			>
				{images.map((src, index) => (
					<SwiperSlide key={index}>
						<div className="gallery-item">
							<img src={src} alt={`Gallery image ${index + 1}`} loading="lazy" />
						</div>
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
}
